import { CardInfoEntity, RoleInfoEntity } from "@/model/system";
import { RoleType, Sex, categoryMap, Categorys } from "@/model/Base";

export default class enumUtils {
  static makeArray(enumType: number) {
    let types: any = [];
    for (const key in categoryMap) {
      let category = categoryMap[key];
      if (category.BaseID != enumType) {
        continue;
      }
      types.push({ text: category.CategoryName, code: category.CategoryCode, value: category.CategoryID });
    }
    return types;
  }
  static makeCategorys(enumType: number) {
    let types: any = [];
    for (const key in categoryMap) {
      let category = categoryMap[key];
      if (category.BaseID != enumType) {
        continue;
      }
      types.push({ ...category });
    }
    return types;
  }

  //   static makeMap(enumType: number) {
  //     let obj: any = [];
  //     for (const key in categoryMap) {
  //       let category = categoryMap[key];
  //       if (category.BaseID != enumType) {
  //         continue;
  //       }
  //       obj[category.CategoryID] = category;
  //     }
  //     return types;
  //   }
}
